<template>
  <div>
    <div>
      <Header></Header>
    </div>
    <div class="router-view">
      <div>
        <LeftLevelNavigation></LeftLevelNavigation>
      </div>
      <div class="router-view-right">
        <div class="router-view-right-top" v-if="routerView == '/'">
          <img src="@/assets/images/country.png" alt="" srcset="" />
          <div class="pro_head_search">
            <div class="pro_head_search_title">区域：</div>
            <div class="pro_head_search_select">
              <el-select v-model="area" placeholder="请选择区域">
                <el-option
                  v-for="item in areaArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="router-view-main">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routerView: "",

      area: Number(localStorage.getItem("region")), //地区：1=美国，2=欧区，3=中国
      areaArr: [
        { value: 1, label: "美区" },
        { value: 2, label: "欧区" },
        { value: 3, label: "中国区" },
      ],
    };
  },
  methods: {},
  created() {
    // this.area = localStorage.getItem('region');
  },
  watch: {
    $route: {
      handler(to) {
        console.log(to);
        this.routerView = to.fullPath;
      },
      immediate: true,
    },
    area: {
      handler(newVal) {
        if (localStorage.getItem("region") != newVal) {
          this.$store.dispatch("updateGlobalVar", newVal);
          window.location.reload();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.router-view {
  display: flex;

  .router-view-right {
    width: calc(100% - 250px);
    height: calc(100vh - 80px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    .router-view-right-top {
      width: 100%;
      height: 58px;
      flex-shrink: 0;
      background-color: #fff;
      display: flex;
      align-items: center;
      padding-left: 48px;

      img {
        width: 20px;
        height: 19px;
      }

      .pro_head_search {
        display: flex;
        align-items: center;
        margin-left: 11px;

        .pro_head_search_title {
          font-size: 14px;
          letter-spacing: 1px;
          color: #333333;
        }

        .pro_head_search_select {
          // width: 180px;
          width: 180px;
          height: 32px;

          ::v-deep .el-select {
            width: 100%;
            height: 100%;

            .el-input {
              width: 100%;
              height: 100%;

              .el-input__inner {
                width: 100%;
                height: 100%;
              }

              .el-input__suffix {
                .el-input__suffix-inner {
                  .el-select__caret {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
            }
          }
        }
      }
    }

    .router-view-main {
      width: 100%;
      padding: 20px;
    }
  }
}
</style>
